<script setup lang="ts">
const localePath = useLocalePath();
const { currentOrganization, handleLogout } = useOrganizationApi();

const dropdownMenu = computed(() => {
  // TODO: Restrict according to permissions
  const canManageSubscription =
    currentOrganization.value?.userCanManageSubscription;
  const canInviteUsers = currentOrganization.value?.userCanManageSubscription;

  const options = [
    {
      text: currentOrganization.value?.name ?? "",
      classes: "text-sm text-gray-600",
      to: localePath({ name: "settings" }),
      disabled: !currentOrganization.value,
    },
    {
      text: "buttons.settings",
      icon: "fa6-solid:gears",
      to: localePath({ name: "settings" }),
      disabled: !canManageSubscription,
    },
    {
      text: "buttons.invite",
      icon: "fa6-solid:user-plus",
      to: localePath({ name: "invites" }),
      disabled: !canInviteUsers,
    },
    {
      text: "auth.logout",
      icon: "fa6-solid:right-from-bracket",
      disabled: false,
      action: handleLogout,
    },
  ];

  return options.filter((option) => !option.disabled);
});
</script>
<template>
  <layout-dynamic-region-content region="userMenu">
    <template #default="{ layoutRegionBinds }">
      <div
        v-for="option in dropdownMenu"
        :key="option.text"
        class="flex justify-end"
      >
        <component
          :is="option.to ? 'router-link' : 'button'"
          class="flex justify-end items-center gap-2 min-w-[90px] hover:opacity-60 whitespace-nowrap"
          :class="option.classes"
          :to="option.to"
          :type="!option.to ? 'button' : undefined"
          @click="
            (option.action && option.action(),
            layoutRegionBinds?.closeDropdown())
          "
        >
          <base-icon
            v-if="option.icon"
            :name="option.icon"
            size="14px"
            class="text-ngray-1"
          />
          <span class="text-sm text-ngray-1 whitespace-nowrap">
            {{ $t(option.text) }}
          </span>
        </component>
      </div>
    </template>
  </layout-dynamic-region-content>
</template>
